import { RouteType } from "../config";
import DashboardIcon from "@material-ui/icons/Dashboard";
import NILPage from "../../pages/NIL/NILPage";

const grupoNIL: RouteType = {
  path: "/nucleo_inteligencia_logistica",
  show: true,
  element: <NILPage />,
  state: "NIL",
  sidebarProps: {
    displayText: "NIL",
    icon: <DashboardIcon />,
  },
};

export default grupoNIL;
